module.exports = __webpack_public_path__ + "static/img/12.c691f9ea.png";